import qs from 'qs'
import { itemSorts } from '../../constants/itemSearchConstatnts.js'

const { RECOMMENDED } = itemSorts

/**
 * @typedef {Object} SearchConditions
 * @property {string} sortSelectedValue
 * @property {string} keyword
 * @property {string|null} via
 * @property {number|null} lowerBudget
 * @property {number|null} higherBudget
 * @property {number[]} selectedCategoryIds
 * @property {number[]} selectedSceneIds
 * @property {number[]} selectedReceivingKindIds
 * @property {number} currentPage
 */

const toBudget = value => (value ? Number(value) : null)
const toIds = value => (value ? value.map(Number) : [])

/**
 * @param {string} search URL のクエリ文字列
 * @returns {SearchConditions}
 */
export const parseSearchConditions = search => {
  const parsed = qs.parse(search, { ignoreQueryPrefix: true })
  return {
    sortSelectedValue: parsed.sort_key || RECOMMENDED.key,
    keyword: parsed.keyword || '',
    via: parsed.via || null,
    lowerBudget: toBudget(parsed.lower_budget),
    higherBudget: toBudget(parsed.higher_budget),
    selectedCategoryIds: parsed.category_id
      ? [Number(parsed.category_id)]
      : toIds(parsed.category_ids),
    selectedSceneIds: parsed.scene_id
      ? [Number(parsed.scene_id)]
      : toIds(parsed.scene_ids),
    selectedReceivingKindIds: toIds(parsed.item_receiving_kinds),
    currentPage: parsed.page_number ? Number(parsed.page_number) : 1
  }
}

/**
 * @param {SearchConditions} conditions
 * @returns {string}
 */
export const toSearchUrl = conditions => {
  const query = qs.stringify(
    {
      sort_key:
        conditions.sortSelectedValue === RECOMMENDED.key
          ? undefined
          : conditions.sortSelectedValue,
      lower_budget: conditions.lowerBudget || undefined,
      higher_budget: conditions.higherBudget || undefined,
      category_ids: conditions.selectedCategoryIds,
      scene_ids: conditions.selectedSceneIds,
      item_receiving_kinds: conditions.selectedReceivingKindIds,
      page_number:
        conditions.currentPage === 1 ? undefined : conditions.currentPage,
      keyword: conditions.keyword || undefined
    },
    { arrayFormat: 'brackets' }
  )
  return query ? `/items?${query}` : '/items'
}
